import type { EditorCommand } from '@atlaskit/editor-common/types';

import type { RemixThinkingPluginMeta } from '../pm-plugins/remix-thinking/remix-thinking-plugin';
import { remixThinkingPluginKey } from '../pm-plugins/remix-thinking/remix-thinking-plugin';

export const setRemixThinkingComplete =
	(isComplete: boolean): EditorCommand =>
	({ tr }) => {
		// `legacy-complete-false` also clears the decoration and update metadata, and is dropped while
		// a machine owns lifecycle writes, so pair it with the presentation reset that survives.
		const meta: RemixThinkingPluginMeta = isComplete
			? { lifecycle: { kind: 'legacy-complete' } }
			: { presentation: { kind: 'reset' }, lifecycle: { kind: 'legacy-complete-false' } };

		tr.setMeta(remixThinkingPluginKey, meta);

		return tr;
	};
